import * as React from "react";
import { NameView } from "./styles";
export const NameViews = (props) => {
    const { name, titleTag, columnNum } = props;
    return (React.createElement(NameView, { columnNum: columnNum },
        titleTag && React.createElement("img", { className: "titleTag", src: titleTag }),
        name));
};
